import { mutatorAction } from 'satcheljs';
import { bizchatSidepaneStore } from '../store/store';
import { getBizChatCompositeKey } from '../utils/getBizChatCompositeKey';
import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import type { WindowKey } from 'owa-bizchat-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export const updateBizchatLoadedMapMutator: (
    isLoaded: boolean,
    mailboxInfo: MailboxInfo,
    windowKey: WindowKey
) => void = mutatorAction('updateBizchatLoadedMapMutator', (isLoaded, mailboxInfo, windowKey) => {
    if (isGlobalFeatureEnabled('mon-copilot-bizchat-loading-bar')) {
        const key = getBizChatCompositeKey(getAccountKeyForMailboxInfo(mailboxInfo), windowKey);
        bizchatSidepaneStore().isBizchatSidepaneLoadedMap.set(key, isLoaded);
    }
});
